'use client';

import { c as _c } from "react/compiler-runtime";
import { type FactiiiTag, type SpaceTimeTag } from '@shared/all/domains/factiiis';
import { useFactiiiHandlers } from '@shared/utils/hooks/useFactiiiHandlers';
import { Trash } from 'lucide-react';
import { useState } from 'react';
import TimezoneSelect from 'react-timezone-select';
import Button from '../../common/Button';
type Props = {
  dateSaveHandler: (date: string | undefined, time: string | undefined, timezone: SpaceTimeTag['timezone'] | undefined) => void;
  triggerRemove: () => void;
  defaultTimezone: {
    value: string;
    label: string;
    offset: number;
  };
  tag: FactiiiTag;
  disabled?: boolean;
};
const DefaultDateTimeFactiii = t0 => {
  const $ = _c(57);
  const {
    dateSaveHandler,
    defaultTimezone,
    tag,
    disabled,
    triggerRemove
  } = t0;
  let t1;
  if ($[0] !== tag.postFactiiis[0].spaceTimes) {
    t1 = tag.postFactiiis[0].spaceTimes?.[0]?.timestamp ? new Date(tag.postFactiiis[0].spaceTimes[0].timestamp).toISOString().split("T")[0] : tag.postFactiiis[0].spaceTimes?.[0]?.date || "";
    $[0] = tag.postFactiiis[0].spaceTimes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [date, setDate] = useState(t1);
  let t2;
  if ($[2] !== tag.postFactiiis[0].spaceTimes) {
    t2 = tag.postFactiiis[0].spaceTimes?.[0]?.timestamp ? new Date(tag.postFactiiis[0].spaceTimes[0].timestamp).toISOString().split("T")[1].slice(0, 5) : tag.postFactiiis[0].spaceTimes?.[0]?.time || "";
    $[2] = tag.postFactiiis[0].spaceTimes;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [time, setTime] = useState(t2);
  const [timezone, setTimezone] = useState(tag.postFactiiis[0].spaceTimes?.[0]?.timezone || defaultTimezone);
  const {
    validateDateTime
  } = useFactiiiHandlers();
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const now = new Date();
      const date_0 = now.toISOString().split("T")[0];
      const time_0 = now.toTimeString().slice(0, 5);
      const timezoneValue = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const timezone_0 = {
        value: timezoneValue,
        label: timezoneValue.replace(/_/g, " "),
        offset: now.getTimezoneOffset() / -60
      };
      setTimezone(timezone_0);
      setDate(date_0);
      setTime(time_0);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleSetNow = t3;
  let t4;
  if ($[5] !== date || $[6] !== time || $[7] !== timezone || $[8] !== validateDateTime) {
    t4 = validateDateTime(date, time, timezone);
    $[5] = date;
    $[6] = time;
    $[7] = timezone;
    $[8] = validateDateTime;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const isValidDateTime = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e_0 => setDate(e_0.target.value);
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== date || $[12] !== disabled) {
    t6 = <input id="datePicker" title="Date Chooser" type="date" className="w-full rounded-md border border-ds-border-standard bg-background-secondary p-2 text-textPrimary focus:outline-none focus:ring-2 focus:ring-primary" value={date} disabled={disabled} onChange={t5} />;
    $[11] = date;
    $[12] = disabled;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e_1 => setTime(e_1.target.value);
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== disabled || $[16] !== time) {
    t8 = <input id="timePicker" title="Time Chooser" type="time" className="w-full rounded-md border border-ds-border-standard bg-background-secondary p-2 text-textPrimary focus:outline-none focus:ring-2 focus:ring-primary" value={time} onChange={t7} disabled={disabled} />;
    $[15] = disabled;
    $[16] = time;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <div className="flex items-center space-x-2">{t6}{t8}</div>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = selectedTimezone => {
      if (typeof selectedTimezone === "string") {
        setTimezone({
          value: selectedTimezone,
          label: selectedTimezone,
          offset: 0
        });
      } else {
        setTimezone({
          value: selectedTimezone.value,
          label: selectedTimezone.label,
          offset: selectedTimezone.offset ?? 0
        });
      }
    };
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      control: _temp2,
      menu: _temp3,
      option: _temp4,
      singleValue: _temp5
    };
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== disabled || $[24] !== timezone) {
    t12 = <div className="text-textPrimary"><TimezoneSelect onChange={t10} value={timezone} styles={t11} isDisabled={disabled} /></div>;
    $[23] = disabled;
    $[24] = timezone;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== date || $[27] !== dateSaveHandler || $[28] !== time || $[29] !== timezone) {
    t13 = () => {
      dateSaveHandler(date, time, timezone);
    };
    $[26] = date;
    $[27] = dateSaveHandler;
    $[28] = time;
    $[29] = timezone;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const t14 = disabled || !isValidDateTime;
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <Button type="button" classNames="w-full" borderTransparent={false} text="Save" onClick={t13} disabled={t14} />;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => handleSetNow();
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== disabled) {
    t17 = <Button variant="SECONDARY" type="button" classNames="w-full" borderTransparent={false} text="Now" onClick={t16} disabled={disabled} />;
    $[35] = disabled;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== tag.isNewFactiii || $[38] !== tag.isRemovedFactiii || $[39] !== triggerRemove) {
    t18 = !tag.isNewFactiii && <Button variant="CLEAR" classNames={`p-1.5 ml-auto ${tag.isRemovedFactiii ? "border-destructive" : ""}`} borderTransparent={false} icon={<Trash width={20} height={20} color={tag.isRemovedFactiii ? "red" : "rgba(var(--text-secondary-color))"} />} tooltip={tag.isRemovedFactiii ? "Marked for removal" : "remove"} onClick={e_2 => {
      e_2.stopPropagation();
      triggerRemove();
    }} />;
    $[37] = tag.isNewFactiii;
    $[38] = tag.isRemovedFactiii;
    $[39] = triggerRemove;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== dateSaveHandler || $[42] !== defaultTimezone || $[43] !== tag.isNewFactiii) {
    t19 = tag.isNewFactiii && <Button variant="CLEAR" classNames="p-1.5 ml-auto" borderTransparent={false} text="Clear" tooltip="Clear the inputs" onClick={e_3 => {
      e_3.stopPropagation();
      setDate("");
      setTime("");
      setTimezone(defaultTimezone);
      dateSaveHandler(undefined, undefined, undefined);
    }} />;
    $[41] = dateSaveHandler;
    $[42] = defaultTimezone;
    $[43] = tag.isNewFactiii;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t15 || $[46] !== t17 || $[47] !== t18 || $[48] !== t19) {
    t20 = <div className="flex items-center space-x-2">{t15}{t17}{t18}{t19}</div>;
    $[45] = t15;
    $[46] = t17;
    $[47] = t18;
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== isValidDateTime) {
    t21 = !isValidDateTime && <><p className="mt-2 text-destructive">Please enter valid date/time</p></>;
    $[50] = isValidDateTime;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== t12 || $[53] !== t20 || $[54] !== t21 || $[55] !== t9) {
    t22 = <div onClick={_temp} className="space-y-2">{t9}{t12}{t20}{t21}</div>;
    $[52] = t12;
    $[53] = t20;
    $[54] = t21;
    $[55] = t9;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  return t22;
};
export default DefaultDateTimeFactiii;
function _temp(e) {
  e.stopPropagation();
}
function _temp2(base) {
  return {
    ...base,
    backgroundColor: "rgba(var(--background-secondary-color))",
    borderColor: "rgba(var(--border-color))",
    color: "rgba(var(--text-color))"
  };
}
function _temp3(base_0) {
  return {
    ...base_0,
    backgroundColor: "rgba(var(--background-secondary-color))"
  };
}
function _temp4(styles, t0) {
  const {
    isFocused,
    isSelected
  } = t0;
  return {
    ...styles,
    backgroundColor: isSelected ? "rgba(var(--primary))" : isFocused ? "rgba(var(--hover-color))" : "rgba(var(--background-secondary-color))",
    color: "rgba(var(--text-color))",
    ":active": {
      ...styles[":active"],
      backgroundColor: "rgba(var(--primary))"
    }
  };
}
function _temp5(base_1) {
  return {
    ...base_1,
    color: "rgba(var(--text-color))"
  };
}